'use strict';
var Modal = require('../modalUtilities');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    const statusSuccessClass = 'alert-success';
    const statusErrorClass = 'alert-danger';
    var status;
    if (data.success) {
        status = statusSuccessClass;
    } else {
        status = statusErrorClass;
    }

    var messageModalDiv = '.js-wishlist-color-id-'.concat(data.colorId);
    $(messageModalDiv).find('.js-add-to-wishlist-message')
        .removeClass(statusSuccessClass).removeClass(statusErrorClass)
        .addClass(status).html(data.msg);

    let modalTarget = $(messageModalDiv);
    let modal = new Modal(modalTarget);
    $('.cc-add-to-wishlist-background').show();
    $(messageModalDiv).show();
    modal.open();

    setTimeout(function () {
        $('.js-close-add-to-wishlist-message').trigger('click');
    }, 2000);
}

/**
 * fills or empties the PDP heart icon
 * @param {boolean} fill - true for filled the heart, false for empty heart
 */
function updateHeartIcon(fill) {
    var $heart = $('.js-add-to-wishlist');
    if (fill) {
        $heart.find('.stroke').addClass('cc-hide').css('display', 'none');
        $heart.find('.fill').removeClass('cc-hide').css('display', '');
    } else {
        // empty heart
        $heart.find('.fill').addClass('cc-hide').css('display', 'none');
        $heart.find('.stroke').removeClass('cc-hide').css('display', '');
    }
}
/**
 * gets the pid for the selected:
 * - variation product (a variant with a color and a size)
 * - variation group (a variant with only a color)
 * - not the variation master (product without color and size)
 * @returns the pid of the selected variation product/group.
 */
function getSelectedVariantPid() {
    var pid;
    var selectedSize = $('.js-select-size.cc-active').data('attr-value');
    if (selectedSize) {
        // use pid of the selected size and color variation
        if ($('.cc-product-detail').length){
            pid = $('.cc-product-detail').data('pid');
        } else {
            pid = $('.product-detail').data('pid');
        }
    } else {
        // calculate pid for the selected color variation (without size)
        var skuMaster = $('#skuMaster').val();
        var colorVariation = $('.js-color-choice.cc-active').attr('data-attr-value');
        pid = skuMaster + colorVariation;   // pid concatenation wishlist
    }
    return pid;
}

module.exports = {
    addToWishlist: function () {
        $(document).on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            var button = $(this);
            var url = $(this).data('href');
            var pid = $('#skuMaster').val();
            var pidButton = $(this).data('pid');
            var color = $(this).data('color');
            var colorId = $('.js-color-choice.cc-active').data('attr-value');

            var variantPid = getSelectedVariantPid();
            if (variantPid){
                pid = variantPid;
            } else {
                var size = $('.js-selected-size-socialList').val();

                if (color != null && color != undefined) {
                    pid = pid.concat(color);
                }
    
                if (colorId != null && !pid.includes(colorId)) {
                    pid = pid.concat(colorId);
                }
    
                if (size != null && size != undefined && size != '') {
                    pid = pid.concat(size);
                } else {
                    if (pidButton.includes(pid)) {
                        pid = pidButton;
                    }
                }
            }

            var optionId = null;
            var optionVal = null;
            if (!url || !pid || !colorId) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    colorId: colorId,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    $.spinner().stop();
                    displayMessage(data, button);
                    // fill heart and trigger update for number of items in wishlist badge.
                    updateHeartIcon(true);
                    $('body').trigger('wishlist:updateQuantity');
                    // analytics
                    dataLayer.push({
                        event: 'wishlist',
                        eventCategory: 'Wish List',
                        eventAction: 'add',
                        eventLabel: pid
                    });
                    // END
                },
                error: function (err) {
                    $.spinner().stop();
                    displayMessage(err, button);
                    $('body').trigger('wishlist:updateQuantity');
                }
            });
        });
    },

    closeModal: function () {
        $(document).on('click', '.js-close-add-to-wishlist-message', function(e) {
            let modalTarget = $(this).parent().parent();
            let modal = new Modal(modalTarget);

            $('.cc-add-to-wishlist-background').hide();
            modalTarget.hide();
            modal.close();
            if ($('body').hasClass('cc-blocked')) $('body').removeClass('cc-blocked');
            $('.js-add-to-wishlist').removeAttr('disabled');
        });
    },

    checkProductInWishlist: function () {
        // get pid of current variation product or variation group
        var pid = getSelectedVariantPid();

        // perform ajax call to Wishlist-ContainsProduct
        $.ajax({
            url: $('#wishlistContainsProductURL').val(),
            type: 'GET',
            data : {
                pid: pid
            },
            dataType: 'json',
            success: function(res) {
                if (! res.error) {
                    updateHeartIcon(res.result);
                }
            }
        });
    },

    /**
     * when the selected product variant changes,
     * check if it exist within the customer wishlist
     */
    updateWishlistButton: function () {
        var self = this;
        $('body').on('wishlist:productVariantChanged', function() {
            self.checkProductInWishlist();
        });
    },
};
